export interface IPurchaseStatus {
    id: number,
    name: string
}

export enum PurchaseStatus {
    Active = 1,
    Returned = 2
}